export const VIRTUAL_FOOTBALL_ID = 67;
export const VIRTUAL_SPORT_IDS = [VIRTUAL_FOOTBALL_ID, 68, 69] as const;

export type VirtualLeagueSort = 'MORE_MATCHES' | 'MOST_RECENT' | 'ALPHABETICAL';

export interface VirtualCatalogSportDto {
    id: number;
    internal_id: number;
    name: string;
    name_ru?: string | null;
    photo_url?: string | null;
    number_of_periods?: number | null;
}

export interface VirtualCatalogLeagueDto {
    id: number;
    sync_id?: string | null;
    name: string;
    name_ru?: string | null;
    sport_id: number;
    sport_name: string;
    photo_url?: string | null;
    match_count: number;
}

export interface VirtualCatalogMatchOddsDto {
    win_1?: number | null;
    draw?: number | null;
    win_2?: number | null;
}

export interface VirtualCatalogMatchDto {
    id: number;
    sport_id: number;
    sport_name: string;
    league_id?: number | null;
    league_name?: string | null;
    home_team_id?: number | null;
    home_team_name?: string | null;
    away_team_id?: number | null;
    away_team_name?: string | null;
    score_home: number;
    score_away: number;
    match_state: number;
    start_date?: string | null;
    created_at?: string | null;
    odds: VirtualCatalogMatchOddsDto;
}

export interface VirtualCatalogPageDto<T> {
    items: T[];
    offset: number;
    limit: number;
    totalItems: number;
}
